import React from 'react'
import ProdIOORetViewRow from './ProdIOORetViewRow'
import withView from '../../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import { UiView, UiViewHeading, UiTitle, UiViewContent } from "../../../../../library/layout/Index";

const ProdIOORetView = (props) => {
    const { formObject, viewData } = props;

    return (
        <>
            <UiView>
                <UiViewHeading>
                    <UiTitle>
                        <span className="uiInline"><SarasTrans value="Stock Returns" /></span>
                    </UiTitle>
                </UiViewHeading>
                <UiViewContent>
                    <ul className="uiListTable">
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Sr No." /></li>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Item Id" /></li>
                                <li className="uiColumnCenter uiColumn200"><SarasTrans value="Item Name" /></li>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Unit" /></li>
                                <li className="uiColumnCenter uiColumn90"><SarasTrans value="Qty Returned" /></li>
                                <li className="uiColumnCenter uiColumn90"><SarasTrans value="Transaction Type" /></li>
                                <li className="uiColumnCenter uiColumn90"><SarasTrans value="Transaction ID" /></li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData ? viewData : {}).map((row, index) => (
                                <li><ProdIOORetViewRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} index={index + 1}/></li>
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>
        </>
    )
}

export default withView(ProdIOORetView, "prodIORet", "");
